export function SettingsPage({ render }) {
  return render();
}
